import { baseAuthorizationServerUrl } from "./config";
import { ApiCapabilitiesService } from "@authzsvc/api-lib";

const capabilitiesUrl = `${baseAuthorizationServerUrl}/ApiCapabilities`;
const capabilitiesService = new ApiCapabilitiesService(capabilitiesUrl);
export default capabilitiesService;
